module.exports = __webpack_public_path__ + "static/media/kod_girisi_ADIM2.a0638095.jpg";